export default "__VITE_ASSET__DLkH9oi2__"